import { PageHeader } from '@ant-design/pro-layout';
import { useNavigate } from 'react-router-dom';

const PageTitle = ({ backUrl, ...props }) => {
  let navigate = useNavigate();

  return (
    <PageHeader
      className="site-page-header"
      onBack={backUrl ? () => navigate(backUrl) : null}
      {...props}
    />
  );
};

export default PageTitle;
